export default "__VITE_ASSET__85217670__"